
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'


export default {
components: {
XHeader,
Group,
XButton,
XInput
},
data () {
return {
pageTitle: '登录',
accountsVal: '',
passwordVal: '',
isLogin: false
}
},
mounted () {
if (this.$store.state.token.length > 0) {
this.isLogin = true;
}else{
this.isLogin = false;
}
},
methods: {
goLogin () {
this.$store.commit('login',{
accounts: this.accountsVal,
password: this.passwordVal
});
},
goLogout () {
this.$store.commit('logout',{});
this.accountsVal = '';
this.passwordVal = '';
}
}
}



// WEBPACK FOOTER //
// ./src/page/Login.vue